var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { apiService } from '../utils/api';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import '../styles/masterListView.css';
var SKELETON_ROW_COUNT = 8;
var Bank = function () {
    var _a, _b;
    var _c = useState([]), banks = _c[0], setBanks = _c[1];
    var _d = useState([]), accounts = _d[0], setAccounts = _d[1];
    var _e = useState(null), selectedBank = _e[0], setSelectedBank = _e[1];
    var _f = useState(false), dialogVisible = _f[0], setDialogVisible = _f[1];
    var _g = useState(false), viewDialogVisible = _g[0], setViewDialogVisible = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState({
        accountNo: '',
        bankName: '',
        branch: '',
        ifsc: ''
    }), newBank = _j[0], setNewBank = _j[1];
    var _k = useState(''), searchInput = _k[0], setSearchInput = _k[1];
    var _l = useState(''), globalFilter = _l[0], setGlobalFilter = _l[1];
    var _m = useState([]), selectedRows = _m[0], setSelectedRows = _m[1];
    var _o = useState(0), first = _o[0], setFirst = _o[1];
    var _p = useState(12), rows = _p[0], setRows = _p[1];
    var _q = useState(['sno', 'accountNo', 'bankName', 'branch', 'ifsc', 'ledgerAccountId']), visibleColumns = _q[0], setVisibleColumns = _q[1];
    var allColumns = [
        { field: 'sno', header: 'S.No' },
        { field: 'accountNo', header: 'Account No.' },
        { field: 'bankName', header: 'Bank Name' },
        { field: 'branch', header: 'Branch' },
        { field: 'ifsc', header: 'IFSC Code' },
        { field: 'ledgerAccountId', header: 'Ledger Account' },
    ];
    var toast = useRef(null);
    useEffect(function () {
        fetchBanks();
        fetchAccounts();
    }, []);
    useEffect(function () {
        var debounce = setTimeout(function () { return setGlobalFilter(searchInput); }, 300);
        return function () { return clearTimeout(debounce); };
    }, [searchInput]);
    useEffect(function () {
        setFirst(0);
    }, [globalFilter]);
    var fetchAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/accounts/type/ASSET')];
                case 1:
                    response = _b.sent();
                    if (response.success)
                        setAccounts(response.data || []);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchBanks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiService.get('/banks')];
                case 2:
                    response = _c.sent();
                    if (response.success) {
                        setBanks(response.data || []);
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to fetch banks' });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.error('Error fetching banks:', error_1);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch banks' });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentBank, response, error_2;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    currentBank = selectedBank || newBank;
                    if (!currentBank.accountNo || !currentBank.accountNo.trim()) {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Validation Error', detail: 'Account No. is required' });
                        return [2 /*return*/];
                    }
                    if (!currentBank.bankName || !currentBank.bankName.trim()) {
                        (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Validation Error', detail: 'Bank Name is required' });
                        return [2 /*return*/];
                    }
                    if (!currentBank.branch || !currentBank.branch.trim()) {
                        (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Validation Error', detail: 'Branch is required' });
                        return [2 /*return*/];
                    }
                    if (!currentBank.ifsc || !currentBank.ifsc.trim()) {
                        (_d = toast.current) === null || _d === void 0 ? void 0 : _d.show({ severity: 'error', summary: 'Validation Error', detail: 'IFSC Code is required' });
                        return [2 /*return*/];
                    }
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 6, , 7]);
                    response = void 0;
                    if (!selectedBank) return [3 /*break*/, 3];
                    return [4 /*yield*/, apiService.put("/banks/".concat(selectedBank.id), selectedBank)];
                case 2:
                    response = _h.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, apiService.post('/banks', newBank)];
                case 4:
                    response = _h.sent();
                    _h.label = 5;
                case 5:
                    if (response.success) {
                        (_e = toast.current) === null || _e === void 0 ? void 0 : _e.show({ severity: 'success', summary: 'Success', detail: "Bank ".concat(selectedBank ? 'updated' : 'saved', " successfully!") });
                        setDialogVisible(false);
                        fetchBanks();
                        resetForm();
                    }
                    else {
                        (_f = toast.current) === null || _f === void 0 ? void 0 : _f.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to save bank' });
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_2 = _h.sent();
                    console.error('Error saving bank:', error_2);
                    (_g = toast.current) === null || _g === void 0 ? void 0 : _g.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while saving' });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            confirmDialog({
                message: 'Are you sure you want to delete this bank? This cannot be undone.',
                header: 'Delete Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, error_3;
                    var _a, _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, apiService.delete("/banks/".concat(id))];
                            case 1:
                                response = _d.sent();
                                if (response.success) {
                                    (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Success', detail: 'Bank deleted successfully!' });
                                    setSelectedRows(function (prev) { return prev.filter(function (b) { return b.id !== id; }); });
                                    fetchBanks();
                                }
                                else {
                                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to delete bank' });
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                error_3 = _d.sent();
                                (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while deleting' });
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }
            });
            return [2 /*return*/];
        });
    }); };
    var handleBulkDelete = function () {
        var count = selectedRows.length;
        confirmDialog({
            message: "Delete ".concat(count, " selected bank").concat(count > 1 ? 's' : '', "? This cannot be undone."),
            header: 'Delete Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                var results, failed, error_4;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Promise.all(selectedRows.map(function (b) { return apiService.delete("/banks/".concat(b.id)); }))];
                        case 1:
                            results = _d.sent();
                            failed = results.filter(function (r) { return !r.success; }).length;
                            if (failed > 0) {
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'warn', summary: 'Partial failure', detail: "".concat(count - failed, " of ").concat(count, " deleted; ").concat(failed, " failed.") });
                            }
                            else {
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'success', summary: 'Success', detail: "".concat(count, " bank").concat(count > 1 ? 's' : '', " deleted successfully!") });
                            }
                            setSelectedRows([]);
                            fetchBanks();
                            return [3 /*break*/, 3];
                        case 2:
                            error_4 = _d.sent();
                            (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while deleting the selected banks' });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }
        });
    };
    var handleView = function (rowData) {
        setSelectedBank(rowData);
        setViewDialogVisible(true);
    };
    var resetForm = function () {
        setSelectedBank(null);
        setNewBank({
            accountNo: '',
            bankName: '',
            branch: '',
            ifsc: ''
        });
    };
    var actionBodyTemplate = function (rowData) {
        if (loading)
            return null;
        return (_jsxs("div", __assign({ className: "mdl-action-group" }, { children: [_jsx("button", __assign({ type: "button", className: "mdl-icon-btn", onClick: function () { return handleView(rowData); }, "aria-label": "View bank", title: "View Details" }, { children: _jsx("i", { className: "pi pi-eye" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn", onClick: function () { setSelectedBank(rowData); setDialogVisible(true); }, "aria-label": "Edit bank", title: "Edit" }, { children: _jsx("i", { className: "pi pi-pencil" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn danger", onClick: function () { return handleDelete(rowData.id); }, "aria-label": "Delete bank", title: "Delete" }, { children: _jsx("i", { className: "pi pi-trash" }) }))] })));
    };
    var serialNumberTemplate = function (rowData, options) {
        if (loading)
            return _jsx(Skeleton, { width: "2rem" });
        return options.rowIndex + 1;
    };
    var accountNoBodyTemplate = function (rowData) {
        if (loading)
            return _jsx(Skeleton, { width: "70%" });
        return _jsx("span", __assign({ className: "mdl-name-cell" }, { children: rowData.accountNo }));
    };
    var textBodyTemplate = function (field) { return function (rowData) {
        if (loading)
            return _jsx(Skeleton, { width: "70%" });
        return rowData[field];
    }; };
    var ledgerBodyTemplate = function (row) {
        if (loading)
            return _jsx(Skeleton, { width: "80%" });
        var a = accounts.find(function (a) { return a.id === row.ledgerAccountId; });
        return a ? _jsxs("span", { children: [a.accountCode, " \u2014 ", a.accountName] }) : _jsx("span", __assign({ className: "text-color-secondary" }, { children: "\u2014" }));
    };
    var filteredBanks = banks.filter(function (b) {
        var term = globalFilter.trim().toLowerCase();
        return !term ||
            b.accountNo.toLowerCase().includes(term) ||
            b.bankName.toLowerCase().includes(term) ||
            b.branch.toLowerCase().includes(term) ||
            b.ifsc.toLowerCase().includes(term);
    });
    var buildExportRow = function (b, idx) { return ({
        'S.No': idx + 1,
        'Account No.': b.accountNo,
        'Bank Name': b.bankName,
        'Branch': b.branch,
        'IFSC Code': b.ifsc,
    }); };
    var handleExport = function () {
        var exportData = filteredBanks.map(buildExportRow);
        var ws = XLSX.utils.json_to_sheet(exportData);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Banks');
        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'banks.xlsx');
    };
    var tableValue = loading
        ? Array.from({ length: SKELETON_ROW_COUNT }, function (_, i) { return ({ id: -(i + 1) }); })
        : filteredBanks;
    return (_jsxs("div", __assign({ className: "card mdl-page" }, { children: [_jsx(Toast, { ref: toast }), _jsxs("div", __assign({ className: "mdl-page-header" }, { children: [_jsxs("div", { children: [_jsx("h1", __assign({ className: "mdl-page-title" }, { children: "Bank Management" })), _jsxs("p", __assign({ className: "mdl-page-subtitle" }, { children: [banks.length, " bank", banks.length === 1 ? '' : 's'] }))] }), _jsxs("div", __assign({ className: "mdl-page-actions" }, { children: [_jsx(Button, { label: "Export", icon: "pi pi-file-excel", className: "mdl-btn-outline", onClick: handleExport }), _jsx(Button, { label: "Add Bank", icon: "pi pi-plus", className: "mdl-btn-primary", onClick: function () {
                                    resetForm();
                                    setDialogVisible(true);
                                } })] }))] })), _jsx("div", __assign({ className: "mdl-toolbar" }, { children: selectedRows.length > 0 ? (_jsxs("div", __assign({ className: "mdl-toolbar-selection" }, { children: [_jsxs("span", __assign({ className: "mdl-selection-count" }, { children: [selectedRows.length, " selected"] })), _jsx(Button, { label: "Export selected", icon: "pi pi-file-excel", className: "mdl-selection-btn", onClick: function () {
                                var exportData = selectedRows.map(buildExportRow);
                                var ws = XLSX.utils.json_to_sheet(exportData);
                                var wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, 'Banks');
                                var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                                saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'banks-selected.xlsx');
                            } }), _jsx(Button, { label: "Delete selected", icon: "pi pi-trash", className: "mdl-selection-btn danger", onClick: handleBulkDelete })] }))) : (_jsxs(_Fragment, { children: [_jsxs("span", __assign({ className: "p-input-icon-left mdl-search" }, { children: [_jsx("i", { className: "pi pi-search" }), _jsx(InputText, { placeholder: "Search account no, bank, branch or IFSC", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, className: "mdl-search-input" })] })), _jsx(MultiSelect, { value: visibleColumns, options: allColumns, onChange: function (e) { return setVisibleColumns(e.value); }, optionLabel: "header", optionValue: "field", placeholder: "Columns", selectedItemsLabel: "Columns", maxSelectedLabels: 0, className: "mdl-columns-wrapper mdl-columns-multiselect" })] })) })), _jsxs(DataTable, __assign({ value: tableValue, selectionMode: "checkbox", selection: selectedRows, onSelectionChange: function (e) { return setSelectedRows(e.value); }, dataKey: "id", paginator: true, first: first, rows: rows, onPage: function (e) { setFirst(e.first); setRows(e.rows); }, removableSort: true, className: "p-datatable-sm mdl-table-header mdl-table-footer", paginatorLeft: _jsxs("div", __assign({ className: "mdl-footer-left" }, { children: [_jsxs("span", __assign({ className: "mdl-footer-count" }, { children: ["Showing ", _jsx("b", { children: filteredBanks.length === 0 ? 0 : first + 1 }), " to ", _jsx("b", { children: Math.min(first + rows, filteredBanks.length) }), " of ", filteredBanks.length] })), _jsxs("span", __assign({ className: "mdl-footer-rpp" }, { children: [_jsx("label", __assign({ htmlFor: "bank-rows-per-page" }, { children: "Rows per page" })), _jsx(Dropdown, { inputId: "bank-rows-per-page", value: rows, options: [12, 25, 50], onChange: function (e) { setRows(e.value); setFirst(0); }, className: "mdl-rows-dropdown" })] }))] })), paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink", emptyMessage: globalFilter ? 'No banks match your filters' : 'No banks yet' }, { children: [_jsx(Column, { selectionMode: "multiple", headerStyle: { width: '44px' }, style: { width: '44px' } }), visibleColumns.includes('sno') && _jsx(Column, { field: "sno", header: "S.No", body: serialNumberTemplate, headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", style: { width: '72px' }, sortable: true }), visibleColumns.includes('accountNo') && _jsx(Column, { field: "accountNo", header: "Account No.", body: accountNoBodyTemplate, style: { width: '160px' }, sortable: true }), visibleColumns.includes('bankName') && _jsx(Column, { field: "bankName", header: "Bank Name", body: textBodyTemplate('bankName'), style: { width: '200px' }, sortable: true }), visibleColumns.includes('branch') && _jsx(Column, { field: "branch", header: "Branch", body: textBodyTemplate('branch'), style: { width: '160px' }, sortable: true }), visibleColumns.includes('ifsc') && _jsx(Column, { field: "ifsc", header: "IFSC Code", body: textBodyTemplate('ifsc'), style: { width: '140px' }, sortable: true }), visibleColumns.includes('ledgerAccountId') && _jsx(Column, { field: "ledgerAccountId", header: "Ledger Account", body: ledgerBodyTemplate }), _jsx(Column, { header: "Action", body: actionBodyTemplate, headerClassName: "mdl-col-numeric", style: { width: '150px' } })] })), _jsxs(Dialog, __assign({ visible: dialogVisible, onHide: function () { return setDialogVisible(false); }, header: selectedBank ? 'Edit Bank' : 'Add Bank', modal: true, className: "p-fluid", footer: _jsxs("div", { children: [_jsx(Button, { label: "Cancel", icon: "pi pi-times", onClick: function () { return setDialogVisible(false); }, className: "p-button-text" }), _jsx(Button, { label: "Save", icon: "pi pi-check", onClick: handleSave, className: "p-button-primary" })] }) }, { children: [_jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "accountNo" }, { children: "Account No. *" })), _jsx(InputText, { id: "accountNo", value: (selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.accountNo) || newBank.accountNo, onChange: function (e) {
                                    if (selectedBank) {
                                        setSelectedBank(__assign(__assign({}, selectedBank), { accountNo: e.target.value }));
                                    }
                                    else {
                                        setNewBank(__assign(__assign({}, newBank), { accountNo: e.target.value }));
                                    }
                                }, required: true, className: "w-full" })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "bankName" }, { children: "Bank Name *" })), _jsx(InputText, { id: "bankName", value: (selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.bankName) || newBank.bankName, onChange: function (e) {
                                    if (selectedBank) {
                                        setSelectedBank(__assign(__assign({}, selectedBank), { bankName: e.target.value }));
                                    }
                                    else {
                                        setNewBank(__assign(__assign({}, newBank), { bankName: e.target.value }));
                                    }
                                }, required: true, className: "w-full" })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "branch" }, { children: "Branch *" })), _jsx(InputText, { id: "branch", value: (selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.branch) || newBank.branch, onChange: function (e) {
                                    if (selectedBank) {
                                        setSelectedBank(__assign(__assign({}, selectedBank), { branch: e.target.value }));
                                    }
                                    else {
                                        setNewBank(__assign(__assign({}, newBank), { branch: e.target.value }));
                                    }
                                }, required: true, className: "w-full" })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "ifsc" }, { children: "IFSC Code *" })), _jsx(InputText, { id: "ifsc", value: (selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.ifsc) || newBank.ifsc, onChange: function (e) {
                                    if (selectedBank) {
                                        setSelectedBank(__assign(__assign({}, selectedBank), { ifsc: e.target.value }));
                                    }
                                    else {
                                        setNewBank(__assign(__assign({}, newBank), { ifsc: e.target.value }));
                                    }
                                }, required: true, className: "w-full" })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "ledgerAccountId" }, { children: "Ledger Account (Chart of Accounts)" })), _jsx(Dropdown, { id: "ledgerAccountId", value: (_b = (_a = selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.ledgerAccountId) !== null && _a !== void 0 ? _a : newBank.ledgerAccountId) !== null && _b !== void 0 ? _b : null, options: accounts, optionLabel: "accountName", optionValue: "id", placeholder: "Select account...", filter: true, showClear: true, className: "w-full", itemTemplate: function (opt) { return _jsxs("span", { children: [opt.accountCode, " \u2014 ", opt.accountName] }); }, valueTemplate: function (opt) { return opt ? _jsxs("span", { children: [opt.accountCode, " \u2014 ", opt.accountName] }) : _jsx("span", __assign({ className: "p-placeholder" }, { children: "Select account..." })); }, onChange: function (e) {
                                    if (selectedBank) {
                                        setSelectedBank(__assign(__assign({}, selectedBank), { ledgerAccountId: e.value }));
                                    }
                                    else {
                                        setNewBank(__assign(__assign({}, newBank), { ledgerAccountId: e.value }));
                                    }
                                } }), _jsx("small", __assign({ className: "text-color-secondary" }, { children: "Links this bank to a ledger account for double-entry accounting. Auto-created when adding a new bank." }))] }))] })), _jsx(Dialog, __assign({ visible: viewDialogVisible, onHide: function () { return setViewDialogVisible(false); }, header: "View Bank Details", modal: true, className: "p-fluid", style: { width: '40vw' }, closeOnEscape: true, footer: _jsx("div", { children: _jsx(Button, { label: "Close", icon: "pi pi-times", onClick: function () { return setViewDialogVisible(false); }, className: "p-button-text" }) }) }, { children: selectedBank && (_jsxs("div", __assign({ className: "grid" }, { children: [_jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "Account No.:" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedBank.accountNo }))] })) })), _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "Bank Name:" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedBank.bankName }))] })) })), _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "Branch:" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedBank.branch }))] })) })), _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "IFSC Code:" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedBank.ifsc }))] })) })), _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: "Ledger Account:" })), _jsx("div", __assign({ className: "p-2 bg-gray-100 rounded" }, { children: selectedBank.ledgerAccountId
                                            ? (function () { var a = accounts.find(function (a) { return a.id === selectedBank.ledgerAccountId; }); return a ? "".concat(a.accountCode, " \u2014 ").concat(a.accountName) : "Account ID: ".concat(selectedBank.ledgerAccountId); })()
                                            : _jsx("span", __assign({ className: "text-color-secondary" }, { children: "Not linked (falls back to 1010)" })) }))] })) }))] }))) }))] })));
};
export default Bank;
